import React from 'react';
import {
  UserRecord,
  PostData,
  FeedData,
  FeedTagData,
  FollowData,
  VoteData,
} from '../model/types';

export interface CacheContextType {
  getUserRecord: (id: string) => UserRecord | undefined;
  getUserRecordFromUsername: (username: string) => UserRecord | undefined;
  getPost: (id: string) => PostData | undefined;
  allUsers: () => UserRecord[];
  allFeeds: () => FeedData[];
  allPosts: () => PostData[];
  allFollows: () => FollowData[];
  allVotes: () => VoteData[];
  allFeedTags: () => FeedTagData[];
  getFeedFromTag: (tag: string) => FeedData | undefined;
  getFeedFromID: (id: string) => FeedData | undefined;
  getFollow: (id: string) => FollowData | undefined;
  loadMorePosts: () => void;
  hasMorePosts: boolean;
  loadingMorePosts: boolean;
  loadingStatus: {
    users: boolean;
    posts: boolean;
    feeds: boolean;
    follows: boolean;
    votes: boolean;
  };
}
export const CacheContext = React.createContext<CacheContextType>({
  getUserRecord: () => ({} as UserRecord),
  getUserRecordFromUsername: () => ({} as UserRecord),
  getPost: () => ({} as PostData),
  allUsers: () => [],
  allFeeds: () => [],
  allPosts: () => [],
  allFollows: () => [],
  allVotes: () => [],
  allFeedTags: () => [],
  getFeedFromTag: () => ({} as FeedData),
  getFeedFromID: () => ({} as FeedData),
  getFollow: () => ({} as FollowData),
  loadMorePosts: () => {},
  hasMorePosts: false,
  loadingMorePosts: false,
  loadingStatus: {
    users: false,
    posts: false,
    feeds: false,
    follows: false,
    votes: false,
  },
});
